import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'vector-chart',
})

export default class VectorChart extends Vue {

    @Prop()
    public isLearnerIdenity!: boolean;

    // -------------------------------------------------------------
    // Properties

    @Prop()
    private chartData: any;

    private contentList: any = [];

    @Prop({default: 150})
    private maxWidth?: any;

    @Prop({default: 100})
    private maxHeight?: any;

    private skylinePoints: any = [];

    @Prop({default: false})
    private isShowText?: boolean;

    @Prop({default: false})
    private isShowScale?: boolean;

    @Prop({default: false})
    private isSmallCard?: boolean;

    @Watch('chartData')
    private onChangesChartData() {
        this.parseData();
    }


    // ---------------------------------------------------------------------------
    // Hooks

    private mounted() {
        if (this.chartData.length) {
            this.parseData();
        }
    }

    // ---------------------------------------------------------------------------
    // Methods

    private drawChart() {
        d3.select(this.$el).select('svg').remove();
        const columnWidth = this.maxWidth / this.contentList.length;
        const svg = d3.select(this.$el).append('svg');
        svg.attr('width', parseInt(this.maxWidth, 10))
            .attr('height', parseInt(this.maxHeight, 10))
            .append('g').attr('id', 'bar-chart');

        const barcontainer = d3.select(this.$el).select('#bar-chart');
        const g: any = barcontainer.selectAll('.rect')
            .data(this.contentList)
            .enter()
            .append('g')
            .attr('class', 'rect');

        g.append('rect')
            .attr('x', (d: any, i: number) => {
                return columnWidth * i;
            })
            .attr('y', 0)
            .attr('width', columnWidth)
            .attr('height', (d: any) => {
                return d.count;
            });

        g.append('rect')
            .attr('class', 'un-filled')
            .attr('x', (d: any, i: number) => {
                return columnWidth * i;
            })
            .attr('y', (d: any) => d.count)
            .attr('width', columnWidth)
            .attr('height', (d: any) => {
                return this.maxHeight - d.count;
            });

        if (this.isShowScale) {
            const svgAxis = svg.attr('width', parseInt(this.maxWidth, 10)  + 50)
            .attr('height', parseInt(this.maxHeight, 10) + 50);
            barcontainer.attr('transform', 'translate(30, 10)');
            const yAxis = d3.scaleLinear().domain([0, 1]).range([0, this.maxHeight]);
            const scaleAxis = d3.axisLeft(yAxis);
            if (this.isSmallCard) { scaleAxis.ticks(1); }
            svgAxis.append('g')
                .attr('transform', 'translate(30, 10)')
                .attr('class', 'x-axis')
                .call(scaleAxis);
            }

        if (this.isShowText) {
            const fb = g.append('g')
                .attr('class', 'text-group')
                .attr('transform', (d: any, i: number) => {
                    return `translate(${columnWidth * i}, 5) rotate(90)`;
                }).append('foreignObject')
                .attr('width', 200)
                .attr('height', columnWidth)
                .attr('y', - columnWidth);

            fb.append('xhtml:div')
                .append('div')
                .attr('class', `text-item ${this.isSmallCard ? 'small-font' : ''}`)
                .html((d: any) => {
                    return d.label;
                });
              }

        this.drawSkyline();
    }

    private drawSkyline() {
        const svg = d3.select(this.$el).select('#bar-chart');
        const skylineBox = svg.append('g').attr('id', 'vector-skyline');
        let points = '';
        this.skylinePoints.map((skylinePoint: any) => {
            points += ` ${skylinePoint.x1},${skylinePoint.y1} ${skylinePoint.x2},${skylinePoint.y2}`;
          });
        skylineBox.append('polyline')
            .attr('points', points)
            .attr('class', 'skyline');
    }

    private parseData() {
        this.skylinePoints = [];
        this.contentList = this.chartData.map((item: any, index: number) => {
            const columnWidth = this.maxWidth / this.chartData.length;
            this.skylinePoints.push({
                x1: index * columnWidth,
                y1: item.value * this.maxHeight,
                x2: index * columnWidth + columnWidth,
                y2: item.value * this.maxHeight,
            });
            return {
                label: (this.isLearnerIdenity && item.label === 'perseverance') ? 'Self efficacy' : item.label,
                count: item.value * this.maxHeight,
            };
        });
        this.drawChart();
    }

}
